import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

// Attach bearer token as fallback (cross-origin cookie may not always set)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jb_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
